module.exports = __webpack_public_path__ + "static/img/装饰20.ae95fe0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/jewelryPendant/imgs/装饰20.svg
// module id = cBtm
// module chunks = 2